import React, { useCallback, useEffect, useMemo } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, LinearProgress } from '@material-ui/core'

const COLUMNS = [
  "#",
  "Дата купівлі",
  "Маршрут",
  "Дата відправлення",
  "Звідки",
  "Куди",
  "Ціна",
]

const renderTableHeadCell = label => (
  <TableCell padding='dense' key={label}>
    {label}
  </TableCell>
)

export const PassengerBookings = props => {
  useEffect(() => {
    props.getPassengerBookings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const rowClasses = useMemo(() => ({
    confirmed: props.classes.highlightConfirmed,
    noResponse: props.classes.highlightNoResponse,
    noPaid: props.classes.highlightNotPaid,
    blacklist: props.classes.highlightBlacklist,
  }), [props.classes])
  /* eslint-disable */
  const renderBooking = useCallback(({
    id, createdDate, routeName, departureDate, from, to, price, status
  }, index) => (
      <TableRow key={id} className={rowClasses[status]}>
        <TableCell padding='dense'>
          {index + 1}
        </TableCell>

        <TableCell padding='dense'>
          {typeof createdDate === "string" ? createdDate.split(' ')[0] : ''}
        </TableCell>

        <TableCell padding='dense'>
          {routeName}
        </TableCell>

        <TableCell padding='dense'>
          {typeof departureDate === "string" ? departureDate : ''}
        </TableCell>

        <TableCell padding='dense'>
          {from}
        </TableCell>

        <TableCell padding='dense'>
          {to}
        </TableCell>

        <TableCell padding='dense'>
          {price}
        </TableCell>
      </TableRow>
    ), [rowClasses])
  /* eslint-enable */

  const renderLoading = useCallback(() => (
    props.isLoading && (
      <TableRow>
        <TableCell colSpan='7'>
          <LinearProgress />
        </TableCell>
      </TableRow>
    )
  ), [props.isLoading])

  return (
    <Table>
      <TableHead>
        <TableRow>
          {COLUMNS.map(renderTableHeadCell)}
        </TableRow>
      </TableHead>
      <TableBody>
        {renderLoading()}
        {props.bookings.map(renderBooking)}
      </TableBody>
    </Table>
  );
};

PassengerBookings.defaultProps = {
  isLoading: true
}


// WEBPACK FOOTER //
// ./src/components/PassengerBookings/PassengerBookings.js